





















import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

@Component({})
export default class Totals extends Vue {
  @Prop() params!: { userId: null, date: null };
  result = {};


  @Watch('params', {deep: true})
  async onParamsChange() {
    if (this.params.date && this.params.userId) {
      await this.axios.get('api/GetDailyActivitiesByUser', {
        params: {
          date: this.params.date,
          userId: this.params.userId
        }
      }).then(result => {
        this.result = result.data;
      }).catch(err => {

      }).finally(() => {

      });
    }
  }
}
